import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "base-form header" }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_input_phone_component = _resolveComponent("input-phone-component")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_employee_schedule_component = _resolveComponent("employee-schedule-component")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("h2", null, [
                _createTextVNode(_toDisplayString(_ctx.isCreatingView ? 'Новый сотрудник' : `Карточка сотрудника`) + " ", 1),
                _createElementVNode("span", null, _toDisplayString(`${_ctx.ruleForm.lastname ?? ''} ${ _ctx.ruleForm.firstname ? `${_ctx.ruleForm.firstname.substring(0,1)}.` : ''}`), 1)
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_tabs, {
                class: "employee-tabs",
                modelValue: _ctx.activeTab,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.activeTab) = $event)),
                style: {"margin":"0 1rem"}
              }, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createBlock(_component_el_tab_pane, {
                    label: "Основное",
                    name: "common"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form, {
                        model: _ctx.ruleForm,
                        ref: "employeeForm",
                        class: "base-form",
                        "status-icon": "",
                        rules: _ctx.rules
                      }, {
                        default: _withCtx(() => [
                          (!_ctx.isCreatingView)
                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 0,
                                label: "Дата создания",
                                "label-position": "top"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.ruleForm.date,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ruleForm.date) = $event)),
                                    readonly: true
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_el_form_item, {
                            label: "Фамилия",
                            "label-position": "top",
                            prop: "lastname"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.ruleForm.lastname,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ruleForm.lastname) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            label: "Имя",
                            "label-position": "top",
                            prop: "firstname"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.ruleForm.firstname,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ruleForm.firstname) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            label: "Отчество",
                            "label-position": "top",
                            prop: "middlename"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.ruleForm.middlename,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.ruleForm.middlename) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            label: "Телефон",
                            "label-position": "top",
                            prop: "phone"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_input_phone_component, {
                                modelValue: _ctx.ruleForm.phone,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.ruleForm.phone) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            label: "Почтовый адрес (e-mail)",
                            "label-position": "top",
                            prop: "email"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.ruleForm.email,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.ruleForm.email) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            label: "Ощущает себя",
                            "label-position": "top"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_radio_group, {
                                modelValue: _ctx.ruleForm.isMale,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.ruleForm.isMale) = $event))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_radio_button, { value: true }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Мужчиной")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_radio_button, { value: false }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Не мужчиной")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 11 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    label: "Должность",
                                    "label-position": "top",
                                    prop: "position"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_select, {
                                        modelValue: _ctx.ruleForm.positionId,
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.ruleForm.positionId) = $event)),
                                        placeholder: "Должность"
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.positions, (e) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: e.id,
                                              label: e.name,
                                              value: e.id
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 2 }),
                              _createVNode(_component_el_col, { span: 11 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    label: "Грейд",
                                    "label-position": "top",
                                    prop: "positionGrade"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_select, {
                                        modelValue: _ctx.ruleForm.gradeId,
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.ruleForm.gradeId) = $event)),
                                        placeholder: "Грейд"
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.positionGrades, (e) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: e.id,
                                              label: e.name,
                                              value: e.id
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 11 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    label: "Подразделение",
                                    "label-position": "top",
                                    prop: "employer"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_select, {
                                        modelValue: _ctx.ruleForm.employerId,
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.ruleForm.employerId) = $event)),
                                        placeholder: ""
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employers, (e) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: e.id,
                                              label: e.name,
                                              value: e.id
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 2 }),
                              _createVNode(_component_el_col, { span: 11 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    label: "Бранч",
                                    "label-position": "top",
                                    prop: "employerBranch"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_select, {
                                        modelValue: _ctx.ruleForm.employerBranchId,
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.ruleForm.employerBranchId) = $event)),
                                        placeholder: ""
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employerBranches, (e) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: e.id,
                                              label: e.name,
                                              value: e.id
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            label: "Дата оформления в штат",
                            "label-position": "top",
                            prop: "hireDate"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                modelValue: _ctx.ruleForm.hireDate,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.ruleForm.hireDate) = $event)),
                                type: "date",
                                format: "DD.MM.YYYY",
                                placeholder: "Дата оформления"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            label: "Дата рождения",
                            "label-position": "top",
                            prop: "birthdate"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                modelValue: _ctx.ruleForm.birthdate,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.ruleForm.birthdate) = $event)),
                                type: "date",
                                format: "DD.MM.YYYY",
                                placeholder: "Выберите дату рождения"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          (!_ctx.isCreatingView)
                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 1,
                                label: _ctx.employee?.user?.login ? 'Пользователь' : '',
                                "label-position": "top"
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.employee?.user?.login)
                                    ? (_openBlock(), _createBlock(_component_el_text, {
                                        key: 0,
                                        class: "mx-1",
                                        type: "primary"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.employee.user.login), 1)
                                        ]),
                                        _: 1
                                      }))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                        _createVNode(_component_el_text, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode("пользователь не создан "),
                                            _createVNode(_component_el_link, {
                                              style: {"line-height":"18px","margin-top":"-3px"},
                                              type: "primary",
                                              onClick: _ctx.onCreateAndLinkUserClick
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("создать")
                                              ]),
                                              _: 1
                                            }, 8, ["onClick"])
                                          ]),
                                          _: 1
                                        })
                                      ]))
                                ]),
                                _: 1
                              }, 8, ["label"]))
                            : _createCommentVNode("", true),
                          (!_ctx.isCreatingView)
                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 2,
                                label: "Увольнение",
                                "label-position": "top"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_checkbox, {
                                    modelValue: _ctx.ruleForm.isFired,
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.ruleForm.isFired) = $event)),
                                    label: "Уволен",
                                    size: "large"
                                  }, null, 8, ["modelValue"]),
                                  _createTextVNode("   "),
                                  _createVNode(_component_el_date_picker, {
                                    disabled: !_ctx.ruleForm.isFired,
                                    modelValue: _ctx.ruleForm.fireDate,
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.ruleForm.fireDate) = $event)),
                                    type: "date",
                                    format: "DD.MM.YYYY",
                                    placeholder: "Выберите дату"
                                  }, null, 8, ["disabled", "modelValue"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_el_form_item, {
                            label: "Заметки",
                            "label-position": "top"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.ruleForm.notes,
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.ruleForm.notes) = $event)),
                                maxlength: "5000",
                                "show-word-limit": "",
                                type: "textarea",
                                placeholder: "Заметки (опционально)"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, null, {
                            default: _withCtx(() => [
                              (!_ctx.isCreatingView)
                                ? (_openBlock(), _createBlock(_component_el_button, {
                                    key: 0,
                                    type: "primary",
                                    onClick: _ctx.onUpdateEmployeeClick
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Сохранить ")
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"]))
                                : _createCommentVNode("", true),
                              (_ctx.isCreatingView)
                                ? (_openBlock(), _createBlock(_component_el_button, {
                                    key: 1,
                                    type: "primary",
                                    onClick: _ctx.onCreateEmployeeClick
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Создать ")
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model", "rules"])
                    ]),
                    _: 1
                  })), [
                    [_directive_loading, _ctx.isEmployeeAsyncOperationPending]
                  ]),
                  _createVNode(_component_el_tab_pane, {
                    label: "График работы",
                    name: "schedule",
                    disabled: _ctx.isCreatingView
                  }, {
                    default: _withCtx(() => [
                      (!_ctx.isCreatingView && _ctx.activeTab == 'schedule')
                        ? (_openBlock(), _createBlock(_component_employee_schedule_component, {
                            key: 0,
                            "employee-id": _ctx.employee!.id
                          }, null, 8, ["employee-id"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}